import React from "react";
import { useTranslation } from "react-i18next";
import ServicePlan from "./ServicePlan";
import "../styles/ServicePlans.css";

const ServicePlans = ({ servicePlans }) => {
  const { t } = useTranslation();

  return (
    <div className="rounded mb-4">
      {servicePlans.map((plan, index) => (
        <ServicePlan

        key={index}
        
       
        serviceId={plan.serviceId}
         servicePK={plan.servicePK}
         serviceName={plan.serviceName}
         serviceDescription={plan.serviceDescription}

        />
      ))}
    </div>
  );
};

export default ServicePlans;
